import { render, staticRenderFns } from "./ResourceSharing.vue?vue&type=template&id=9bc72bc4&scoped=true&"
import script from "./ResourceSharing.vue?vue&type=script&lang=js&"
export * from "./ResourceSharing.vue?vue&type=script&lang=js&"
import style0 from "./ResourceSharing.vue?vue&type=style&index=0&id=9bc72bc4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc72bc4",
  null
  
)

export default component.exports